import React from 'react';
import DecorativeBorder from 'chameleon/packages/blue-book-player/DecorativeBorder';
import CrossOutToggle from './CrossOutToggle';
import { isMCQ } from '../utility/progressHelpers';
import MarkForReview from '../library/MarkForReview';
import QuestionCalculator from '../library/QuestionCalculator';

const CrossOutToolbar = ({
  isStudentAccount,
  questionNr,
  question,
  crossOutReducer,
  canMask,
  learnosityQuestionApi,
}) => {
  const questionIsMcq = isMCQ(question);
  const { learnosityItemReference } = question;
  return (
    <div className="mb-[12px] custom-content-width">
      <div className="w-full h-[30px] flex justify-between bg-bluebook-light-gray">
        <div
          className="flex items-center bg-gray-900 text-white nowrap text-18 font-medium px-0.8"
          role="heading"
          aria-level="2"
          data-cy="question-number"
        >
          {questionNr}
        </div>
        <div className="flex-grow flex items-center justify-start py-0.5 pl-3.5 pr-2.5">
          <MarkForReview learnosityItemReference={learnosityItemReference} />
        </div>
        <div className="flex mr-3.5">
          <QuestionCalculator
            learnosityItemReference={learnosityItemReference}
          />
          {canMask && questionIsMcq ? (
            <CrossOutToggle
              question={question}
              crossOutReducer={crossOutReducer}
              learnosityQuestionApi={learnosityQuestionApi}
              isStudentAccount={isStudentAccount}
            />
          ) : null}
        </div>
      </div>
      <DecorativeBorder segmentNr={28} />
    </div>
  );
};

export default CrossOutToolbar;
